<div class="content-wrapper" style="min-height: 1416.81px; margin-left: 4%; margin-right: 4%;">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-1">
          <div class="col-sm-6">
            <h1>
              <font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;">{{ "ProgrammeReparation.ProgrammeReparation" | translate }}</font>
              </font>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="#">{{ "FileAriane.Home" | translate }}</a></li>
              <li class="breadcrumb-item "><a [routerLink]="['/programme-reparation/all']">{{ "ProgrammeReparation.ProgrammeReparation" | translate }}</a></li>
              <li class="breadcrumb-item active">{{ "FileAriane.List" | translate }}</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>
  
    <!-- Main content -->
    <section class="content">
  
      <!-- Default box -->
  
  
      <div class="card">
        <div class="card-header" style="background-color: #17a2b8;color: white;">
          <h1 class="card-title">
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"> {{ "ProgrammeReparation.ProgrammeReparationAll" | translate }}</font>
            </font>
          </h1>
          <button *ngIf="canCreate" [routerLink]="['/programme-reparation/add']" type="button" class="btn btn-primary float-right">
            <i class="fas fa-plus"></i> {{ "Forms.Marques.Ajouter" | translate }}
          </button>
        </div>
        <div class="card-body p-0">
          <table id="example1" class="table table-bordered table-striped">
            <thead>
              <tr>
                <th style="width: 1%">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                      #
                    </font>
                  </font>
                </th>
  
                <th style="width: 10%">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                      {{ "ProgrammeReparation.VehiculeLabel" | translate }}
                    </font>
                  </font>
                </th>

                <th style="width: 10%">
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">
                        {{ "ProgrammeReparation.MecanicienLabel" | translate }}
                      </font>
                    </font>
                </th>

                <th style="width: 10%">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                      {{ "ProgrammeReparation.PanneLabel" | translate }}
                    </font>
                  </font>
                </th>
                <th style="width: 15%">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                      {{ "ProgrammeReparation.DescriptionLabel" | translate }}
                    </font>
                  </font>
                </th>
                <th style="width: 10%">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                      {{ "ProgrammeReparation.DateDebutLabel" | translate }}
                    </font>
                  </font>
                </th>
  
                <th style="width: 10%">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                      {{ "ProgrammeReparation.DateFinLabel" | translate }}
                    </font>
                  </font>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of programme_reparations?.data,let i = index" id="{{ item.id }}">
                <td>
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">
                      {{ i+1 }}
                    </font>
                  </font>
                </td>
                <td>
                  <a>
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">
                        {{ item.immatriculation }}
                      </font>
                    </font>
                  </a>
                </td>
                <td>
                    <a>
                      <font style="vertical-align: inherit;">
                        <font style="vertical-align: inherit;">
                          {{ item.mecanicien }}
                        </font>
                      </font>
                    </a>
                </td>
                <td>
                  <a>
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">
                        {{ item.panne }}
                      </font>
                    </font>
                  </a>
                </td>
                <td>
                  <a>
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">
                        {{ item.description }}
                      </font>
                    </font>
                  </a>
                </td>
                <td>
                  <a>
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">
                        {{ item.date_debut }}
                      </font>
                    </font>
                  </a>
                </td>
                <td>
                  <a>
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">
                        {{ item.date_fin }}
                      </font>
                    </font>
                  </a>
                </td>
  
                <td class="project-actions text-right">
  
                  <a class="btn btn-primary btn-sm" href="javascript:void(0)" data-bs-placement="top" title="details"  (click)="detailsProgramme(item.id)">
                    <i class="fas fa-eye"></i>
                  </a>
                  &nbsp;
                  <a *ngIf="canUpdate" class="btn btn-info btn-sm" href="javascript:void(0)" data-bs-placement="top" title="modifier"  (click)="editProgramme(item.id)">
                    <i class="fas fa-pencil-alt">
                    </i>
                  </a>
                  &nbsp;
                  <a *ngIf="canDelete" class="btn btn-danger btn-sm" href="javascript:void(0)" data-bs-placement="top" title="supprimer"  (click)="deleteProgramme(item.id)">
                    <i class="fas fa-trash">
                    </i>
                  </a>
                </td>
              </tr>
  
            </tbody>
          </table>
          <div class="card-footer">
            <!-- <nav aria-label="Navigation dans la page des contacts">
              <ul class="pagination justify-content-center m-0">
                <li class="page-item"><a (click)="getPage(programme_reparations.prev_page_url)" class="page-link">
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">{{ 'General.Previous' | translate }}</font>
                    </font>
                  </a></li>
                <li class="page-item"><a (click)="getPage(programme_reparations.next_page_url)" class="page-link">
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit;">{{ 'General.next' | translate }}</font>
                    </font>
                  </a></li>
              </ul>
            </nav> -->
          </div>
        </div>
        <!-- /.card-body -->
      </div>
      <!-- /.card -->
  
    </section>
    <!-- /.content -->
  </div>
